var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_75_1260)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.27749 15.1983C4.43301 15.1983 1.30518 12.0704 1.30518 8.22597C1.30518 4.3815 4.43301 1.25366 8.27749 1.25366C12.122 1.25366 15.2498 4.3815 15.2498 8.22597C15.2498 12.0704 12.122 15.1983 8.27749 15.1983Z",
    fill: "#F9F2E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.27751 1.68945C4.67326 1.68945 1.74097 4.62175 1.74097 8.22599C1.74097 11.8302 4.67326 14.7625 8.27751 14.7625C11.8818 14.7625 14.814 11.8302 14.814 8.22599C14.814 4.62175 11.8818 1.68945 8.27751 1.68945Z",
    fill: "#FFCC4D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M13.0056 12.7319C11.816 13.9825 10.1339 14.7626 8.27751 14.7626C4.67371 14.7626 1.74097 11.8298 1.74097 8.22602C1.74097 5.69856 3.18336 3.4979 5.2925 2.41284C4.17257 3.58507 3.48404 5.17127 3.48404 6.91871C3.48404 10.5225 6.41679 13.4553 10.0206 13.4553C11.097 13.4553 12.1123 13.1938 13.0056 12.7319Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4499 8.56582C11.4499 9.08003 11.2058 9.53324 10.8093 9.75113C10.6524 9.83829 10.4868 9.88185 10.3169 9.88185C10.1295 9.88185 9.93776 9.8252 9.7678 9.72062C9.37563 9.47223 8.92241 9.47223 8.53023 9.72062C8.20777 9.92108 7.81993 9.93414 7.48874 9.75113C7.0922 9.53324 6.84814 9.08003 6.84814 8.56582C6.84814 8.08648 7.07039 7.64635 7.43645 7.41541C8.50845 6.73995 9.78959 6.73995 10.8616 7.41541C11.2276 7.64635 11.4499 8.08648 11.4499 8.56582Z",
    fill: "#494943"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6437 9.82083C10.5347 9.86443 10.4258 9.88184 10.3168 9.88184C10.1295 9.88184 9.93772 9.82519 9.76777 9.72061C9.37559 9.47222 8.92238 9.47222 8.5302 9.72061C8.26002 9.89056 7.94625 9.92541 7.6543 9.82083C7.71095 9.73367 7.7763 9.65524 7.8504 9.59424C8.66529 8.91878 9.63268 8.91878 10.4476 9.59424C10.5217 9.65524 10.587 9.73367 10.6437 9.82083Z",
    fill: "#353530"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.2453 5.23649C6.11785 5.23649 5.99146 5.18074 5.90528 5.0735C5.75464 4.88604 5.78464 4.61177 5.97231 4.46091L7.13322 3.52852C7.32047 3.37809 7.59517 3.40787 7.74581 3.59555C7.89646 3.783 7.86646 4.05727 7.67879 4.20813L6.51787 5.14053C6.43744 5.20499 6.34105 5.23649 6.2453 5.23649ZM11.7633 5.17563C11.6803 5.17563 11.5962 5.15201 11.522 5.10244L10.2147 4.2309C10.0145 4.09749 9.9604 3.82683 10.0938 3.62661C10.2272 3.42638 10.4972 3.37191 10.6981 3.50575L12.0054 4.37729C12.2056 4.5107 12.2597 4.78136 12.1263 4.98158C12.0422 5.10754 11.9041 5.17563 11.7633 5.17563Z",
    fill: "#2B2B33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.62387 6.91861C7.98487 6.91861 8.27752 6.52841 8.27752 6.04708C8.27752 5.56574 7.98487 5.17554 7.62387 5.17554C7.26287 5.17554 6.97021 5.56574 6.97021 6.04708C6.97021 6.52841 7.26287 6.91861 7.62387 6.91861Z",
    fill: "#2B2B33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6742 6.91861C11.0352 6.91861 11.3278 6.52841 11.3278 6.04708C11.3278 5.56574 11.0352 5.17554 10.6742 5.17554C10.3132 5.17554 10.0205 5.56574 10.0205 6.04708C10.0205 6.52841 10.3132 6.91861 10.6742 6.91861Z",
    fill: "#2B2B33"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_75_1260"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.8162,
    height: 14.8162,
    fill: "white",
    transform: "translate(0.869385 0.817871)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSad);
export default __webpack_public_path__ + "static/media/sad.b4f07817490321679a2c0a61392d1ad5.svg";
export { ForwardRef as ReactComponent };